
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyPresetSection from './components/WhyPresetSection';
import ZollerAdvantagesSection from './components/ZollerAdvantagesSection';
import ResultsSection from './components/ResultsSection';
import ProductComparisonSection from './components/ProductComparisonSection';
import ROICalculatorSection from './components/ROICalculatorSection';
import CoreBenefitsSection from './components/CoreBenefitsSection';
import StorySection from './components/StorySection';
import FAQSection from './components/FAQSection';
import FinalMessageSection from './components/FinalMessageSection';
import ProcessSection from './components/ProcessSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <WhyPresetSection />
      <ZollerAdvantagesSection />
      <ResultsSection />
      <ProductComparisonSection />
      <ROICalculatorSection />
      <CoreBenefitsSection />
      <StorySection />
      <FAQSection />
      <FinalMessageSection />
      <ProcessSection />
      <ContactSection />
      <Footer />
    </div>
  );
}